export default "__VITE_ASSET__0e77a41d__"